import { render, staticRenderFns } from "./RegProductSelect.vue?vue&type=template&id=13e42f55&"
import script from "./RegProductSelect.vue?vue&type=script&lang=js&"
export * from "./RegProductSelect.vue?vue&type=script&lang=js&"
import style0 from "./RegProductSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports